module.exports = __webpack_public_path__ + "img/motorway_10x2.3cc53a8b.svg";